import CalculationTable from "./CalculationTable";

export default CalculationTable;